import request from '@/router/axios';

//const urlPrefix = process.env.VUE_APP_LOCAL_DEVELOPMENT == 'false' ? '/wage' : '/wage'
//const urlPrefix = "http://192.168.251.61:8888/biz"
const urlPrefix = process.env.VUE_APP_LOCAL_DEVELOPMENT == 'false' ? '/wage' : '/wage'

console.log(process.env)

//分页查询理批处理信息
export function getBatchInfoList(obj){
    return request({
        url: urlPrefix+'/batchInfo/page',
        method: 'post',
        data: obj
    })
}

// 计算薪资明细数据
export function calculateSalaryDetail(data){
    return request({
        url: urlPrefix+'/batchInfo/calculate',
        method: 'post',
        data: data
    })
}

//删除薪资批次数据
export function removeBatchInfo(ids){
    return request({
        url: urlPrefix+'/batchInfo',
        method: 'delete',
        data: ids
    })
}

//获取表头
export function getSalaryHeaders(templateId,noticeId,batchId,cusId){
    return request({
        url: urlPrefix+'/batchInfo/salaryListHeader',
        method: 'get',
        params:{
            templateId: templateId,
            noticeId:noticeId,
            batchId: batchId,
            cusId: cusId,
        }
    })
}
//获取薪资导入明细数据
export function getSalaryDetailList(batchId,type){
    return request({
        url: urlPrefix+'/batchInfo/salaryDetail',
        method: 'get',
        params:{
            batchId: batchId,
            type:type
        }
    })
}
//获取账单薪资明细
export function getBillSalaryDetailList(noticeId){
    return request({
        url: urlPrefix+'/batchInfo/billSalaryDetail',
        method: 'get',
        params:{
          noticeId: noticeId
        }
    })
}
// 获取表头分类信息
export function getHeaderSetInfo(headerList){
    return request({
        url: urlPrefix+'/batchInfo/headerSetInfo',
        method: 'post',
        data: headerList
    })
}

// 批量删除薪资明细项
export function removeSalaryDetail(ids){
    return request({
        url: urlPrefix+'/batchInfo/salaryDetail',
        method: 'delete',
        data: ids
    })
}

//保存修改过的薪资明细
export function saveChangedSalaryDetail(arr,cusId,batchId){
    return request({
        url: urlPrefix+'/batchInfo/salaryDetail',
        method: 'put',
        data: arr,
        params:{
            cusId: cusId,
            batchId: batchId
        }
    })
}

//查询批次明细错误的数量
export function getDetailErrorCount(batchId){
    return request({
        url: urlPrefix+'/batchInfo/detailErrorCount',
        method: 'post',
        data:batchId
    })
}
// 获取成本中心信息code
export function getCostCenterCode(batchId){
    return request({
        url: urlPrefix+'/batchInfo/costCenter',
        method: 'get',
        params: {batchId: batchId}
    })
}
// 获取批次的流程状态
export function getBatchInfoById(batchId){
    return request({
        url: urlPrefix + '/batchInfo/processSatatus',
        method: 'get',
        params: {batchId: batchId}
    })
}

//账单明细导出
export function exportNoticeDetail(obj){
  return request({
    url: '/biz/batchInfo/export',
    method: 'post',
    responseType: 'arraybuffer',
    data: obj
  })
}


export function getDetailExportInfo(obj){
    return request({
        url: urlPrefix + '/batchInfo/exportSalaryDetail',
        method: 'post',
        responseType: 'arraybuffer',
        data: obj
    })
}

export function updateHeader(obj) {
  return request({
    url: urlPrefix + '/templateItem/updateDefaultHeader',
    method: 'post',
    data: obj
  });
}
export function batchAlertMessage(batchId) {
  return request({
    url: urlPrefix + '/batchInfo/messageList',
    method: 'get',
    params: {batchId: batchId}
  });
}

//导出薪酬付款通知
export function getXcInfoExcel(obj) {
    return request({
      url: urlPrefix + '/batchInfo/export',
      method: 'get',
      params: obj,
      responseType: 'arraybuffer',
    });
  }


